import { render } from "./AOverlay.vue?vue&type=template&id=73971b3a"
import script from "./AOverlay.vue?vue&type=script&lang=js"
export * from "./AOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__